import React from 'react';
import { Flex } from '@chakra-ui/react';
import { IPane, Pane } from './Pane/pane';
import { GamersIcon } from '../../../utils/icons/gamers';
import { DollarIcon } from '../../../utils/icons/dollar';
import { GamesIcon } from '../../../utils/icons/games';
import { useMarketProvider } from '../../../providers/Market/marketProvider';
import { t } from 'i18next';
import { GameControllerIcon } from 'src/utils/icons/gameController';

export const InfoSummary = () => {
	const { playersCount, gamesCount, price } = useMarketProvider();

	const panes: IPane[] = [
		{
			icon: <DollarIcon />,
			name: t('infoSummary.pane.marketplaces').toString(),
			value: '2',
			decorator: '',
		},
		{
			icon: <GamersIcon />,
			name: t('infoSummary.pane.gamers').toString(),
			value: `${playersCount}`,
		},
		{
			icon: <GamesIcon />,
			name: t('infoSummary.pane.games').toString(),
			value: `${gamesCount}`,
		},
		{
			icon: <GameControllerIcon />,
			name: t('infoSummary.pane.creator.topic').toString(),
			value: t('infoSummary.pane.creator.subtopic').toString(),
			action: () => window.location.replace('https://GameContract.io/'),
		},
	];

	return (
		<Flex
			width="100%"
			background="background"
			border="1px solid"
			borderColor="backgroundSecondary"
			borderLeft="none"
			borderRight="none"
			alignItems="center"
			justifyContent="center"
			display={{ base: 'none', hashup: 'flex' }}
		>
			<Flex
				minWidth={{ hashup: 'auto', xl: '1240px' }}
				justifyContent="flex-start"
			>
				{panes.map(pane => (
					<Pane
						key={pane.name}
						data={pane}
					/>
				))}
			</Flex>
		</Flex>
	);
};
